// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__antonio_79dbe7', '__antonio_Fallback_79dbe7'"},"className":"__className_79dbe7","variable":"__variable_79dbe7"};